import { rolesPermissionsStore } from "../stores";

export const useRolesPermissionsStore = () => rolesPermissionsStore;
